import React, { useState } from 'react';
import { CenteredContentLayout } from '../../../components/containers/CenteredContentLayout';
import { PrivacyPolicyContent } from './PrivacyPolicyContent.view';
import { ButtonGroup } from '../../../components/containers/ButtonGroup';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { ViewPersonalDataModal } from '../ViewPersonalDataModal';
import { Link, useNavigate } from 'react-router-dom';
import classes from './Privacy.module.scss';
import topNavClasses from '../../TopNav/TopNav.module.scss';
import logo from 'assets/images/logo.svg';
import { useAuth } from '../../../hooks/useAuth';

export type PrivacyViewProps = {
  //
};

export const PrivacyView = (): JSX.Element => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const [showPersonalDataModal, setShowPersonalDataModal] = useState(false);

  const updatePrivacyPreferencesClickHandler = () => navigate({ pathname: '/settings/account' });
  const updateEmailPreferencesClickHandler = () => navigate({ pathname: '/settings/notifications' });

  return (
    <div className={classes.Privacy}>
      {!isLoggedIn ? (
        <div className={classes.NotLoggedIn}>
          <div className={topNavClasses.TopNav}>
            <Link to={'/'} className={topNavClasses.Logo}>
              <img src={logo} alt={'logo'} />
            </Link>
          </div>
          <h3>Privacy</h3>
          <PrivacyPolicyContent />
        </div>
      ) : (
        <CenteredContentLayout hasSidebar={false}>
          <div className={classes.ButtonGroupWrapper}>
            <div className={classes.ButtonGroupContainer}>
              <ButtonGroup size={'large'}>
                <Button
                  type={'button'}
                  variant={'hollow'}
                  size={'large'}
                  color={ButtonColorsEnum.primary}
                  action={() => setShowPersonalDataModal(true)}>
                  Review Personal Data
                </Button>
                <Button
                  type={'button'}
                  variant={'hollow'}
                  size={'large'}
                  color={ButtonColorsEnum.primary}
                  action={updatePrivacyPreferencesClickHandler}>
                  Update Privacy Preferences
                </Button>
                <Button
                  type={'button'}
                  variant={'hollow'}
                  size={'large'}
                  color={ButtonColorsEnum.primary}
                  action={updateEmailPreferencesClickHandler}>
                  Update Email Preferences
                </Button>
              </ButtonGroup>
            </div>
          </div>
          <PrivacyPolicyContent />
          {showPersonalDataModal && <ViewPersonalDataModal closeModal={() => setShowPersonalDataModal(false)} />}
        </CenteredContentLayout>
      )}
    </div>
  );
};
